export { default } from "./HeaderMediaImage";
